export const apiMessageTemplatesMethods = {
  async getTemplates(opts = {}) {
    const qs = opts?.noCache ? `?t=${Date.now()}` : '';
    return this.request(`/api/message_templates.php${qs}`, { _skipGlobalErrorModal: true });
  },

  async createTemplate(title, body) {
    return this.request('/api/message_templates.php', {
      method: 'POST',
      body: JSON.stringify({ title, body }),
    });
  },

  async updateTemplate(id, title, body) {
    return this.request('/api/message_templates.php', {
      method: 'PUT',
      body: JSON.stringify({ id, title, body }),
    });
  },

  async deleteTemplate(id) {
    return this.request('/api/message_templates.php', {
      method: 'DELETE',
      body: JSON.stringify({ id }),
    });
  },
};
